// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3u8tr","info":"PatientInfo_info__2Xi32"};